<template>
<div class="mt-3">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-3 px-3">
        <h2 class="text-white text-lg">Total cumulé</h2>
    </div>
    <div class="px-2 py-3">
        <div class="mt-3 space-y-1">
            <div class="flex justify-between text-sm" v-if="loyersTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Loyers</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(loyersTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="chargesTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Charges</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(chargesTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="taxeFonciereTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Taxe foncière</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(taxeFonciereTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="pretsTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Prêts</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(pretsTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="montantVente">
                <span class="text-gray-500 dark:text-gray-400">Montant de la vente</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(montantVente) }}</span>
            </div>
        </div>

        <div class="flex justify-between items-center mt-3 pt-2 border-t border-gray-200 dark:border-gray-800">
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Total net</span>
            <span class="text-lg font-medium" :class="total >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ format(total) }}</span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        annees: {
            type: Array,
            default: () => []
        },
        selectedYears: {
            type: Array,
            default: () => []
        },
        montantVente: {
            type: [Number, String, null],
            default: null
        }
    },

    computed: {
        selectedAnnees() {
            return this.annees.filter(annee => this.selectedYears.includes(annee.year));
        },

        loyersTotal() {
            return this.sumField('loyers_total');
        },

        chargesTotal() {
            return this.sumField('charges_total');
        },

        taxeFonciereTotal() {
            return this.sumField('taxe_fonciere_total');
        },

        pretsTotal() {
            return this.sumField('prets_total');
        },

        total() {
            return this.loyersTotal - this.chargesTotal - this.taxeFonciereTotal - this.pretsTotal + Number(this.montantVente || 0);
        }
    },

    methods: {
        sumField(field) {
            return this.selectedAnnees.reduce((sum, annee) => sum + Number(annee[field] || 0), 0);
        },

        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
